import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  footnote: {
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.palette.text.secondary,
  },

  radioContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    cursor: 'pointer',
  },
  defaultCheckbox: {
    opacity: 0.5,

    color: `${theme.palette.primary.main} !important`,
  },
}));
